import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowForwardIos } from '@mui/icons-material';
import { Grid } from '@mui/material';

import {
  STO_CHECK_ROUTES,
  STO_PICK_ROUTES,
  STO_RECEIVE_ROUTES,
} from 'routes/constants';

import UserInfoHeader from './components/UserInfoHeader.component';
import S from './HomePage.styles';

const HomePageSTO: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div>
      <UserInfoHeader />
      {/* Menu Options */}
      {/* Picking Process */}
      <S.MenuOption
        onClick={() => navigate(STO_PICK_ROUTES.ASSIGN)}
        data-testid="BtnMenuSTOPick"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon src="/assets/sto-pick-icon.svg" alt="sto-pick-icon" />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Picking Process</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>

      {/* Checking Process */}
      <S.MenuOption
        onClick={() => navigate(STO_CHECK_ROUTES.CHECK_BASKET)}
        data-testid="BtnMenuSTOCheck"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon src="/assets/sto-check-icon.svg" alt="sto-check-icon" />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Checking Process</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>

      {/* Receiving Process */}
      <S.MenuOption
        onClick={() => navigate(STO_RECEIVE_ROUTES.ASSIGN)}
        data-testid="BtnMenuSTOReceive"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon
              src="/assets/sto-receive-icon.svg"
              alt="sto-receive-icon"
            />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Receiving Process</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>
    </div>
  );
};
export default HomePageSTO;
